import {Heading, HeadingProps, HeadingSizes } from ".";
import React from 'react';
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";

export class HeadingInterface extends ComponentInterfaceBaseClass implements HeadingProps {
    key;
    children;
    eyebrow;
    eyebrowColor;
    allowDangerousHtml;
    headingColor;
    size;
    margin;
    headingTag;
    headingLinkUrl;
    headingLinkUrlClasses;
    tooltipData;
    static initWithSanity(key, feed) {
        const t = new HeadingInterface();
        const config = feed.configs || {};
        t.key = key;
        t.children = feed.heading;
        t.eyebrow = feed.eyebrow;        
        t.tooltipData = feed.tooltip;
        t.eyebrowColor = feed.eyebrowColor || config.eyebrowColor;
        t.headingColor = feed.headingColor || config.color;
        t.headingLinkUrl = feed.headingLinkUrl;
        t.headingLinkUrlClasses = feed?.headingLinkUrlClasses;
        t.allowDangerousHtml = true;        
        t.headingTag = feed.headingTag || config.headingTag;
        const cmssize = feed.size || config.size;
        const size = cmssize && !cmssize.includes('heading-') ? 'heading-' + cmssize : cmssize;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        t.size = (Object as any).values(HeadingSizes).includes(size) && size || undefined;
        /* eslint-enable @typescript-eslint/no-explicit-any */
        t.margin = config?.margin;
        return t;
    }
    toProps(HeadingRuntimeProps?): HeadingProps {
        const props = {
            key: this.key,
            children: this.children,
            eyebrow: this.eyebrow,
            headingColor: this.headingColor, //|| theme.headingColor.color || '',
            eyebrowColor: this.eyebrowColor,
            size: this.size, // || theme.heading.size || '',
            headingTag: this.headingTag,
            allowDangerousHtml: this.allowDangerousHtml,
            margin: this.margin,
            headingLinkUrl: this.headingLinkUrl,
            headingLinkUrlClasses:this.headingLinkUrlClasses,
            tooltipData: this.tooltipData,
            ...HeadingRuntimeProps
        }
        return props;
    }

    toJsx(runtimeProps?: HeadingProps): JSX.Element {
        return React.createElement(Heading, {
            ...this.toProps(runtimeProps), 
            ...runtimeProps,
        });
    }
}